import * as actions from './actions';
import { replaceContact } from 'bundles/apex/deals/helpers/contacts';

export default function(state = null, action) {
  switch (action.type) {

  case actions.SET_DEAL:
    return action.deal;

  case actions.CHANGE_DEAL:
    return {
      ...state,
      ...action.changes,
    };


  case actions.ADD_ATTACHMENT: {
    return {
      ...state,
      attachments: [...state.attachments, action.attachment],
      fileCount: state.fileCount + 1,
    };
  }

  case actions.DELETE_ATTACHMENT: {
    return {
      ...state,
      attachments: state.attachments.filter(attachment => attachment.id !== action.attachment.id),
      fileCount: state.fileCount - 1,
    };
  }


  case actions.SET_ATTACHMENTS:
    return {
      ...state,
      attachments: action.attachments,
    };

  case actions.SET_ATTACHMENT_FOLDERS:
    return {
      ...state,
      attachmentFolders: action.attachmentFolders,
    };

  case actions.SET_CONTACT_ROLES: {
    return {
      ...state,
      contactRoles: action.contactRoles
    };
  }

  case actions.ADD_CONTACT_ROLE: {
    const { contactRole } = action;

    return {
      ...state,
      contactRoles: [
        ...state.contactRoles,
        contactRole
      ]
    };
  }

  case actions.ADD_CONTACT_ROLES: {
    return {
      ...state,
      contactRoles: [
        ...state.contactRoles,
        ...action.contactRoles
      ]
    };
  }

  case actions.CHANGE_CONTACT_ROLE: {
    const updatedContactRole = {
      ...action.contactRole,
      ...action.changes,
    };

    const contactRoles = state.contactRoles.map(contactRole => (
      contactRole == action.contactRole ? updatedContactRole : contactRole
    ));

    return {
      ...state,
      contactRoles
    };
  }

  case actions.UPDATE_CONTACT:
    return { ...state, ...replaceContact(action.contact, state) };

  case actions.ADD_CRITICAL_DATE:
    return {
      ...state,
      [action.name]: action.date
    };

  default:
    return state;
  }
}
